module.exports = __webpack_public_path__ + "img/australia.39d9f050.png";